export default {
    documentStatus: {
        complete: 'Completo',
        pending: 'Pending',
        error: 'Error',
    },
    containerStatus: {
        draft: 'Bozza',
        booked: 'Prenotato',
        inTransit: 'In Transito',
        arrived: 'Arrivato',
        delivered: 'Consegnato',
        onHold: 'In Sospeso',
        cancelled: 'Annullato',
    },
    // Stato fisico del container (modello 2025)
    containerPhysicalStatus: {
        PENDING: 'In Attesa',
        GATE_OUT_EMPTY: 'Uscita Gate (Vuoto)',
        LOADING: 'Caricamento',
        GATE_IN: 'Ingresso Gate',
        LOAD_ON_VESSEL: 'Caricato su Nave',
        VESSEL_DEPARTED: 'Nave Partita',
        IN_TRANSIT: 'In Transito',
        VESSEL_ARRIVED: 'Nave Arrivata',
        DISCHARGED: 'Scaricato',
        GATE_OUT_DELIVERY: 'Uscita Gate (Consegna)',
        DELIVERED: 'Consegnato',
        ON_HOLD: 'In Sospeso',
        CANCELLED: 'Annullato',
    },
    // Stato prenotazione
    bookingStatus: {
        DRAFT: 'Bozza',
        CONFIRMED: 'Confermato',
        IN_PROGRESS: 'In Corso',
        COMPLETED: 'Completato',
        CANCELLED: 'Annullato',
    },
    riskLevel: {
        low: 'Basso',
        medium: 'Medio',
        high: 'Alto',
        critical: 'Critico',
    },
    documentType: {
        billOfLading: 'Bill of Lading',
        invoice: 'Fattura Commerciale',
        phytosanitaryCertificate: 'Certificato Fitosanitario',
        movementCertificate: 'Certificato EUR.1',
        packingList: 'Lista di Imballaggio',
        fumigationCertificate: 'Certificato di Fumigazione',
        sadIcm: 'SAD/ICM',
        coo: 'Certificato di Origine',
        unknown: 'Documento Sconosciuto',
    },
    roles: {
        shipper: 'Shipper',
        consignee: 'Consegnatario',
        receiver: 'Receiver',
        notifyParty: 'Notify Party',
        freightForwarder: 'Freight Forwarder',
        forwarder: 'Spedizioniere',
        carrier: 'Vettore marittimo',
        shipOwner: 'Armatore',
        landTransport: 'Trasporto terrestre',
        customsBroker: 'Dogana',
        portOfLoading: 'Porto imbarco',
        portOfDischarge: 'Porto di sbarco',
        airportStaff: 'Staff aeroporto',
        authority: 'Autorità',
        insuranceProvider: 'Assicurazione',
        inspectionAgency: 'Agenzia di Ispezione',
        sales: 'Sales',
        supplier: 'Fornitore',
    },
    status: {
        active: 'Attivo',
        pending: 'In Attesa',
        rejected: 'Rifiutato',
        suspended: 'Sospeso',
        inactive: 'Inattivo',
        accepted: 'Accettato',
        modified: 'In attesa di risposta',
        confirmed: 'Confermato',
        cancelled: 'Cancellato',
    },
    teamRoles: {
        admin: 'Admin',
        editor: 'Editor',
        viewer: 'Viewer',
    },
};

